<div>
  @if (title) {
    <div class="my-2">
      <div class="row">
        <div class="col">
          <ion-label class="color-medium text-uppercase">{{ title }}</ion-label>
        </div>
      </div>
    </div>
  }

  <div
    (click)="this.onElementClick()"
    style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
    class="px-4 py-1 bg-white"
  >
    <ion-list lines="none">
      <ion-item class="pointer-hover">
        <ion-label>{{ name }}</ion-label>

        <div slot="end" class="color-primary">
          {{ this.textBeforeArrow }}
          <i class="fa-regular {{ this.picto }}"></i>
        </div>
      </ion-item>
    </ion-list>
  </div>

  @if (this.description) {
    <p class="my-3 mb-4 color-medium">
      {{ description }}
    </p>
  }
</div>
